import React, { useState, useEffect, useRef } from 'react';
import '../../styles/SupportChat.css';
import { sendChatMessage, getChatMessages } from '../../services/api';

function SupportChat() {
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState('');
  const chatEndRef = useRef(null);

  useEffect(() => {
    const fetchMessages = async () => {
      try {
        const data = await getChatMessages();
        setMessages(data);
      } catch (err) {
        console.error('Failed to fetch chat messages:', err);
      }
    };
    fetchMessages();
    const interval = setInterval(fetchMessages, 5000); // Poll every 5 seconds
    return () => clearInterval(interval);
  }, []);

  const handleSend = async (e) => {
    e.preventDefault();
    if (newMessage.trim()) {
      const messageData = {
        text: newMessage,
        sender: 'client',
        timestamp: new Date().toLocaleString(),
      };
      try {
        await sendChatMessage(messageData);
        setMessages([...messages, { id: messages.length + 1, ...messageData }]);
        setNewMessage('');
      } catch (err) {
        alert('Failed to send message. Please try again.');
      }
    }
  };

  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  return (
    <div className="sp-support-chat">
      <h2 className="sp-chat-title">Support Chat</h2>
      <div className="sp-chat-window">
        {messages.map((message) => (
          <div
            key={message.id}
            className={`sp-chat-message ${message.sender === 'client' ? 'sp-client-message' : 'sp-admin-message'}`}
          >
            <p className="sp-message-text">{message.text}</p>
            <span className="sp-message-timestamp">{message.timestamp}</span>
          </div>
        ))}
        <div ref={chatEndRef} />
      </div>
      <form className="sp-chat-form" onSubmit={handleSend}>
        <input
          className="sp-chat-input"
          type="text"
          placeholder="Type your message..."
          value={newMessage}
          onChange={(e) => setNewMessage(e.target.value)}
        />
        <button className="sp-chat-btn" type="submit">Send</button>
      </form>
    </div>
  );
}

export default SupportChat;